export default class EnvoiPostal {
    id_module;
    module_enabled = false;
    propose = false;
    selected = false;
    prix = 6;
    adresse_postale = "";

    constructor(id_module) {
        this.id_module = id_module;
    }

    set(data) {
        if (!data) return;
        for (const [key, value] of Object.entries(data)) {
            if (this.hasOwnProperty(key)) {
                this[key] = value;
            }
        }
    }

    isValid() {
        if (!this.selected || !this.propose) {
            return true;
        }
        return String(this.adresse_postale || "").trim().length > 0;
    }

    update_cart() {
        let cart = { prix: 0, nb_articles: 0 };
        if (this.selected && this.propose && this.isValid()) {
            cart.prix = this.prix;
            cart.nb_articles = 1;
        }
        this.cart = cart;
        return cart;
    }

    set_propose(propose) {
        this.propose = propose;
    }

    set_selected(selected) {
        this.selected = selected;
        if (!selected) {
            this.adresse_postale = "";
        }
    }

    set_prix(prix) {
        this.prix = prix;
    }

    set_module_enabled(enabled) {
        this.module_enabled = !!enabled;
    }

    static course_allows_postal_send(course) {
        if (!course) {
            return false;
        }
        if (typeof course.has_postal_send === "function") {
            return course.has_postal_send();
        }
        return course.metadatas?.has_postal_send == "1";
    }

    static selected_courses_from_commande_inscription(commande_inscription, module_courses_list = []) {
        const list = module_courses_list || [];
        if (!commande_inscription) {
            return [];
        }
        if (commande_inscription.type === "course" && commande_inscription.id_item) {
            const course = list.find((c) => c.id == commande_inscription.id_item);
            return course ? [course] : [];
        }
        if (commande_inscription.type === "pack" && commande_inscription.inscriptions?.length) {
            const selected = [];
            for (const inscription of commande_inscription.inscriptions) {
                const id_course = inscription.id_course || inscription.course?.id;
                if (!id_course) {
                    continue;
                }
                const course = list.find((c) => c.id == id_course);
                if (course && !selected.some((c) => c.id == course.id)) {
                    selected.push(course);
                }
            }
            return selected;
        }
        return [];
    }

    is_available_for_selected_courses(selected_courses) {
        if (!selected_courses || selected_courses.length === 0) {
            return false;
        }
        return selected_courses.some((course) => EnvoiPostal.course_allows_postal_send(course));
    }

    apply_course_filter(selected_courses) {
        if (!this.module_enabled) {
            this.set_propose(false);
            this.set_selected(false);
            return;
        }
        if (this.is_available_for_selected_courses(selected_courses)) {
            this.set_propose(true);
        } else {
            this.set_propose(false);
            this.set_selected(false);
        }
    }
}
